/**
 * Enhanced chart color palette with modern, vibrant colors
 * optimized for visual hierarchy and accessibility.
 */
export const RECHARTS_COLORS = [
  '#8B5CF6', // Violet (primary)
  '#10B981', // Emerald
  '#F59E0B', // Amber
  '#EF4444', // Red
  '#3B82F6', // Blue
  '#EC4899', // Pink
  '#14B8A6', // Teal
  '#F97316', // Orange
  '#6366F1', // Indigo
  '#84CC16', // Lime
];

// Named colors for semantic usage
export const CHART_SERIES_COLORS = {
  primary: '#8B5CF6',
  secondary: '#10B981',
  tertiary: '#F59E0B',
  quaternary: '#EF4444',
  success: '#10B981',
  warning: '#F59E0B',
  danger: '#EF4444',
  info: '#3B82F6',
};

// Category-specific color mappings
export const RECOMMENDATION_COLORS = {
  HOME: '#8B5CF6',      // Violet
  PCP: '#10B981',       // Emerald
  URGENT_CARE: '#F59E0B', // Amber
  ER_NOW: '#EF4444',    // Red
};

export const SAVINGS_COLORS = {
  total: '#10B981',     // Emerald for positive savings
  home: '#8B5CF6',      // Violet
  pcp: '#10B981',       // Emerald
  urgentCare: '#F59E0B', // Amber
  projected: '#8B5CF6', // Violet for projections
  historical: '#10B981', // Emerald for historical
};

export const TREND_COLORS = {
  positive: '#10B981',
  negative: '#EF4444',
  neutral: '#6B7280',
};

// Gradient definitions for enhanced visual effects
export const GRADIENT_COLORS = {
  primary: {
    start: '#8B5CF6',
    mid: '#A78BFA',
    end: '#C4B5FD',
  },
  success: {
    start: '#10B981',
    mid: '#34D399',
    end: '#6EE7B7',
  },
  danger: {
    start: '#EF4444',
    mid: '#F87171',
    end: '#FCA5A5',
  },
  warning: {
    start: '#F59E0B',
    mid: '#FBBF24',
    end: '#FCD34D',
  },
};
